import { Dispatch } from 'react'
import { AppState } from '../../store'
import { DiagsAction, HIDE_CONFIRM, SHOW_CONFIRM } from './reducers'

import {
  SHOW_ALERT,
  HIDE_ALERT
} from './reducers'

export function hideAlert() {
  return function (state: AppState, dispatch: Dispatch<DiagsAction>) {
    dispatch({
      type: HIDE_ALERT
    })
  }
}

export function showAlert(title: string, text: string) {
  return function (state: AppState, dispatch: Dispatch<DiagsAction>) {
    dispatch({
      type: SHOW_ALERT,
      title,
      text
    })
  }
}

export type ShowConfirmParams = {
  title?: string
  text: string
  confirmText?: string
  callback: () => void
}

export function showConfirm(params: ShowConfirmParams) {
  return function (state: AppState, dispatch: Dispatch<DiagsAction>) {

    dispatch({
      type: SHOW_CONFIRM,
      showConfirmParams: params
    })
  }
}

export function hideConfirm() {
  return function (state: AppState, dispatch: Dispatch<DiagsAction>) {
    dispatch({
      type: HIDE_CONFIRM
    })
  }
}
